import styled from 'styled-components';

export const Label = styled.label<{ mute?: boolean }>`
  cursor: pointer;

  ${(props) => props.mute && `color: ${props.theme.grey.string()};`}
`;
